<div class="mi-approval-type-method-page container ">
    <div class="row justify-content-center">
        <div class="  col-12 mi-panel-wrraper">
            <div class="mi-white-panel with-shadow">
                <div class="mi-approval-type-method-wrapper col-12">
                    <div class="mi-approval-type-method-title" style="margin-bottom: 20px;">
                        <mc-bar-skeleton [widthBar]="'60%'" [heightBar]="'1.5rem'"></mc-bar-skeleton>
                    </div>

                    <div class="mc-radio-button-group"
                        style="display: flex; flex-direction: column; gap: 1rem; margin-bottom: 20px;">
                        <div style="display: flex; align-items: center; gap: 0.5rem;">
                            <mc-bar-skeleton [widthBar]="'20px'" [heightBar]="'20px'"
                                style="border-radius: 50%;"></mc-bar-skeleton>
                            <mc-bar-skeleton [widthBar]="'250px'" [heightBar]="'1rem'"
                                style="max-width: 150px;"></mc-bar-skeleton>
                        </div>
                        <div style="display: flex; align-items: center; gap: 0.5rem;">
                            <mc-bar-skeleton [widthBar]="'20px'" [heightBar]="'20px'"
                                style="border-radius: 50%;"></mc-bar-skeleton>
                            <mc-bar-skeleton [widthBar]="'250px'" [heightBar]="'1rem'"
                                style="max-width: 250px;"></mc-bar-skeleton>
                        </div>
                    </div>

                    <div style="width: 100%; padding: 1rem;  border-radius: 8px;">
                        <mc-bar-skeleton [widthBar]="'95%'" [heightBar]="'1rem'"></mc-bar-skeleton>
                        <mc-bar-skeleton [widthBar]="'80%'" [heightBar]="'1rem'"
                            style="margin-top: 0.5rem;"></mc-bar-skeleton>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="mi-approval-type-method-navigation  row justify-content-center mc-mt-32">
        <div class="col-md-8 col-xs-12 col-xl-4">
            <mc-bar-skeleton [widthBar]="'100%'" [heightBar]="'3.5rem'"></mc-bar-skeleton>
        </div>
    </div>
</div>